import { Injectable } from '@angular/core';
import { CommonService } from '../Services/common.service';

@Injectable({
  providedIn: 'root'
})
export class SpinnerService {

  constructor(
    private commonService: CommonService
  ) { }

  showSpinner() {
    this.commonService.setSpinner(true);
  }

  hideSpinner() {
    this.commonService.setSpinner(false);
  }
}
